document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-section-type="product"]').forEach(section => {
    section.addEventListener('variant:change', (event) => {
      const variant = event.detail?.variant;
      if (!variant || !variant.featured_image) return;

      const mediaItems = section.querySelectorAll('.product__media-item, [data-media-id]');
      mediaItems.forEach(item => {
        const mediaId = item.dataset.mediaId;
        item.style.display = (mediaId && mediaId == variant.featured_image.id) ? '' : 'none';
      });
    });
  });
});
